import React, { Component } from 'react';
import { Offline } from 'react-detect-offline';
import { Dialog, DialogTitle, DialogContent, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import Navbar from '../HeaderComponents/Navbar/Navbar';
import WithGracefulUnmount from '../GlobalComponents/WithGracefulUnmount/WithGracefulUnmount';
import Footer from '../FooterComponents/Footer/Footer';
import AppRouter from '../../router/AppRouter';
import Banner from '../HeaderComponents/Banner/Banner';
import PageContext from '../../contexts/pageContext';
import WithContexts from '../../contexts/withContexts';
import { COLORS } from '../../utils/Application_Constants';
import { getNotificationsByReceiptId } from '../../services/NotificationsService';
import { FeatureFlag } from '../GlobalComponents/FeatureFlagComponent/FeatureFlag';
import MaintenancePage from '../../pages/MaintenancePage/MaintenancePage';
import { getClinicianAccountV2 } from '../../services/ProfileServices/profileService';

const styles = (theme) => ({
    root: {
        padding: '80px 0',
        minHeight: '800px',
        [theme.breakpoints.down('md')]: {
            paddingTop: '60px',
            marginTop: '25px',
        },
        backgroundColor: COLORS.BLACK_HAZE,
    },
    progressButton: {
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
        whiteSpace: 'nowrap',
    },
});

class Layout extends Component {
    constructor(props, context) {
        super(props);
        this.state = {
            pageName: '',
            openOfflineDialog: true,
            refreshNotifications: [],
            isMaintenanceUser: false,
            clinician: null,
            clinicianInitialLoading: true,
        };
        context.setPageName = this.setPageName;
        context.refreshClinician = this.refreshClinician;
    }

    async componentDidMount() {
        const { account } = this.props.UserContext;
        try {
            // Fire notifications async without blocking clinician display
            this.setRefreshNotifications();

            // Clear loading flag immediately after clinician data loads
            await this.refreshClinician();
            this.setState({ clinicianInitialLoading: false });
        } catch (error) {
            console.warn('Error during initialization');
            this.setState({ clinicianInitialLoading: false });
        }
        const maintenanceUsers = process.env.REACT_APP_MAINTENANCE_USERS;
        const allowedUsers = maintenanceUsers.split(',') || [];
        this.setState({
            isMaintenanceUser: allowedUsers.includes(account?.idToken?.emails?.[0]),
        });
    }

    setPageName = (pageName) => {
        this.setState({ pageName });
    };

    refreshClinician = async () => {
        const { externalId } = this.props.UserContext;
        if (externalId === null || externalId === undefined) {
            return;
        }
        try {
            const clinician = await getClinicianAccountV2(externalId);
            this.setState({ clinician });
        } catch (error) {
            console.warn('Error getting clinician - not critical');
        }
    };

    setRefreshNotifications = async () => {
        const { externalId } = this.props.UserContext;
        if (externalId !== null && externalId !== undefined) {
            try {
                const notifications = await getNotificationsByReceiptId(externalId);
                this.setState({ refreshNotifications: notifications });
            } catch (error) {
                console.warn('Error getting notifications - not critical');
            }
        }
    };

    toggleOfflineDialog = (view) => {
        this.setState({ openOfflineDialog: view });
    };

    renderOfflineContent = () => {
        const { openOfflineDialog } = this.state;
        return (
            <Dialog
                open={openOfflineDialog}
                scroll="body"
                maxWidth="md"
                fullWidth
                onClose={() => this.toggleOfflineDialog(false)}
            >
                <DialogTitle style={{ padding: '8px 16px' }}>
                    <Grid item xs={12}>
                        <h1>Offline Notification Message</h1>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{ padding: '8px 16px' }}>
                    <h3>You are offline, Please check your internet connection</h3>
                </DialogContent>
            </Dialog>
        );
    };

    render() {
        return (
            <>
                <FeatureFlag name="MaintenanceIsOccurring" isFlagEnabled="true">
                    {this.state.isMaintenanceUser ? (
                        <WithGracefulUnmount>
                            <Navbar
                                refreshNotifications={this.state.refreshNotifications}
                                clinician={this.state.clinician}
                                clinicianInitialLoading={this.state.clinicianInitialLoading}
                            />
                            <Banner
                                pageName={this.state.pageName}
                                clinician={this.state.clinician}
                                clinicianInitialLoading={this.state.clinicianInitialLoading}
                            />
                            <AppRouter setRefreshNotifications={this.setRefreshNotifications} />
                            <Footer />
                            <Offline polling={{ url: 'https://ipv4.icanhazip.com' }}>
                                {this.renderOfflineContent()}
                            </Offline>
                        </WithGracefulUnmount>
                    ) : (
                        <MaintenancePage />
                    )}
                </FeatureFlag>
                <FeatureFlag name="MaintenanceIsOccurring" isFlagEnabled="false">
                    <WithGracefulUnmount>
                        <Navbar
                            refreshNotifications={this.state.refreshNotifications}
                            clinician={this.state.clinician}
                            clinicianInitialLoading={this.state.clinicianInitialLoading}
                        />
                        <Banner
                            pageName={this.state.pageName}
                            clinician={this.state.clinician}
                            clinicianInitialLoading={this.state.clinicianInitialLoading}
                        />
                        <AppRouter setRefreshNotifications={this.setRefreshNotifications} />
                        <Footer />
                        <Offline polling={{ url: 'https://ipv4.icanhazip.com' }}>
                            {this.renderOfflineContent()}
                        </Offline>
                    </WithGracefulUnmount>
                </FeatureFlag>
            </>
        );
    }
}

Layout.contextType = PageContext;
// export default Layout;

export default WithContexts(withTranslation()(withStyles(styles)(Layout)));
